import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateAgo',
  pure: true,
  standalone: true,
})
export class DateagoPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return moment(value).fromNow();
    }
    return value;
  }
}
